<template>
  <v-container grid-list-xl fluid>
    <FabricRangeSelector type="Double Roller Blind" :value="selectedFabricGroup" v-on:selected-fabric-group="selectedFabricGroup = $event" :v="$v.selectedFabricGroup" :error="$v.selectedFabricGroup.$error"></FabricRangeSelector>

    <FabricSelector :fabricGroupID="selectedFirstFabricGroup" :value="item.fabric" v-on:selected-fabric="selectedFirstFabric = $event" :v="$v.item.fabric" :error="$v.item.fabric.$error"></FabricSelector>

    <ColorSelector :fabricID="selectedFirstFabric" :value="item.color" v-on:selected-color="item.color = $event" :v="$v.item.color" :error="$v.item.color.$error"></ColorSelector>

    <FabricSelector :fabricGroupID="selectedSecondFabricGroup" :value="item.variations.secondFabric" v-on:selected-fabric="selectedSecondFabric = $event" :v="$v.item.variations.secondFabric" :error="$v.item.variations.secondFabric.$error"></FabricSelector>

    <ColorSelector :fabricID="selectedSecondFabric" :value="item.variations.secondColor" v-on:selected-color="item.variations.secondColor = $event" :v="$v.item.variations.secondColor" :error="$v.item.variations.secondColor.$error"></ColorSelector>

    <DimensionSelector v-on:room="setRoom($event)" :valueName="item.name" :valueWidth="item.width" :valueDrop="item.drop" ref="dimensionSelector" @ready="isReady => readyToSubmitDimension = isReady" :type="this.item.type"></DimensionSelector>

    <CustomizationSelector title="Fitting" :value="item.variations.fitting" :options="['Face Fit', 'Recess Fit']" v-on:selected-option="item.variations.fitting = $event" :v="$v.item.variations.fitting" :error="$v.item.variations.fitting.$error"></CustomizationSelector>

    <CustomizationSelector title="Bracket Type" :value="item.variations.bracketType" :options="['Regular Double Bracket', 'Slimline Double Bracket']" v-on:selected-option="item.variations.bracketType = $event" :v="$v.item.variations.bracketType" :error="$v.item.variations.bracketType.$error"></CustomizationSelector>

    <CustomizationSelector title="Control Side" :value="item.variations.controlSide" :options="['Left', 'Right']" v-on:selected-option="item.variations.controlSide = $event" :v="$v.item.variations.controlSide" :error="$v.item.variations.controlSide.$error"></CustomizationSelector>

    <CustomizationSelector v-show="item.variations.bracketType === 'Slimline Double Bracket'" title="Roll Direction" :value="item.variations.rollDirection" :options="['Top Front - Front Roll & Back Roll', 'Top Front - Both Front Roll', 'Top Back - Front Roll & Back Roll', 'Top Back - Both Back Roll']" v-on:selected-option="item.variations.rollDirection = $event" :v="$v.item.variations.rollDirection" :error="$v.item.variations.rollDirection.$error"></CustomizationSelector>

    <CustomizationSelector v-show="item.variations.bracketType === 'Regular Double Bracket'" title="Roll Direction" :value="item.variations.rollDirection" :options="['Front Roll & Back Roll', 'Both Back Roll', 'Both Front Roll']" v-on:selected-option="item.variations.rollDirection = $event" :v="$v.item.variations.rollDirection" :error="$v.item.variations.rollDirection.$error"></CustomizationSelector>

    <CustomizationSelector title="Control Type" :value="item.variations.controlType" :options="controlType" v-on:selected-option="item.variations.controlType = $event, resetControlType()" :v="$v.item.variations.controlType" :error="$v.item.variations.controlType.$error"></CustomizationSelector>

    <CustomizationSelector title="Motor" v-if="item.variations.controlType === 'Motor'" :value="item.variations.motor" :options="motorType" v-on:selected-option="item.variations.motor = $event, resetMotorOptions()" :v="$v.item.variations.motor" :error="$v.item.variations.motor.$error"></CustomizationSelector>

    <CustomizationSelector title="Motor Options" v-if="item.variations.controlType === 'Motor' && item.variations.motor === 'Wired'" :value="item.variations.motorOption" :options="wiredMotorOptions" v-on:selected-option="item.variations.motorOption = $event" :v="$v.item.variations.motorOption" :error="$v.item.variations.motorOption.$error"></CustomizationSelector>

    <CustomizationSelector title="Motor Options" v-if="item.variations.controlType === 'Motor' && item.variations.motor === 'Wired (Non-RTS)'" :value="item.variations.motorOption" :options="wiredNonRTSMotorOptions" v-on:selected-option="item.variations.motorOption = $event" :v="$v.item.variations.motorOption" :error="$v.item.variations.motorOption.$error"></CustomizationSelector>

    <CustomizationSelector title="Motor Options" v-if="item.variations.controlType === 'Motor' && item.variations.motor === 'Battery'" :value="item.variations.motorOption" :options="batteryMotorOptions" v-on:selected-option="item.variations.motorOption = $event" :v="$v.item.variations.motorOption" :error="$v.item.variations.motorOption.$error"></CustomizationSelector>

    <CustomizationSelector title="Remote" v-if="item.variations.controlType === 'Motor' && item.variations.motor !== 'Wired (Non-RTS)'" :value="item.variations.remote" :options="['Situo Pure 1 channel', 'Situo Pure 5 channel', 'No Remote']" v-on:selected-option="item.variations.remote = $event" :v="$v.item.variations.remote" :error="$v.item.variations.remote.$error"></CustomizationSelector>

    <CustomizationSelector title="Charger" v-if="item.variations.controlType === 'Motor' && item.variations.motor === 'Battery'" :value="item.variations.charger" :options="['Somfy Motor Charger', 'No Charger']" v-on:selected-option="item.variations.charger = $event" :v="$v.item.variations.charger"></CustomizationSelector>

    <CustomizationSelector title="Automation" v-if="item.variations.controlType === 'Motor' && item.variations.motor !== 'Wired (Non-RTS)'" :value="item.variations.automation" :options="['Somfy Connexoon', 'None']" v-on:selected-option="item.variations.automation = $event" :v="$v.item.variations.automation"></CustomizationSelector>

    <CustomizationSelector title="Chain Colour" v-if="item.variations.controlType === 'Chain'" :value="item.variations.chainColor" :options="['Silver Metal (+$5)', 'Black', 'White', 'Grey', 'Black Nickel']" v-on:selected-option="item.variations.chainColor = $event" :v="$v.item.variations.chainColor" :error="$v.item.variations.chainColor.$error"></CustomizationSelector>

    <CustomizationSelector title="Bracket Colour" :value="item.variations.bracketColor" :options="['Black', 'White', 'Grey', 'Ivory']" v-on:selected-option="item.variations.bracketColor = $event" :v="$v.item.variations.bracketColor" :error="$v.item.variations.bracketColor.$error"></CustomizationSelector>

    <CustomizationSelector title="Base Rail Shape" :value="item.variations.baseRailShape" :options="['Oval', 'D30', 'Heavy Duty', 'Small Flat']" v-on:selected-option="item.variations.baseRailShape = $event" :v="$v.item.variations.baseRailShape" :error="$v.item.variations.baseRailShape.$error"></CustomizationSelector>

    <CustomizationSelector title="Base Rail Colour" :value="item.variations.baseRailColor" :options="['Anodised Silver', 'Dune', 'Bronze Pearl', 'Satin Black', 'White', 'Bone', 'Sandstone']" v-on:selected-option="item.variations.baseRailColor = $event" :v="$v.item.variations.baseRailColor" :error="$v.item.variations.baseRailColor.$error"></CustomizationSelector>

    <div v-if="incInstall">
      <v-checkbox label="Install?" color="primary" v-model="customInstall"></v-checkbox>
      <v-text-field v-if="customInstall" label="Install Price" v-model="item.installPrice"></v-text-field>
    </div>

    <v-textarea name="notes" label="Line Item Notes" v-model="item.notes"></v-textarea>
    <v-btn v-if="!edit" @click="addItem()" color="primary">Add {{ item.type }}</v-btn>
    <v-btn v-else @click="addItem()" color="primary">Update {{ item.type }}</v-btn>
    <b>${{ (item.total).toFixed(2) }}</b>
  </v-container>
</template>

<script>
import ItemService from '@/services/ItemService.js'

import FabricRangeSelector from '@/components/parts/FabricRangeSelector'
import FabricSelector from '@/components/parts/FabricSelector'
import ColorSelector from '@/components/parts/ColorSelector'
import CustomizationSelector from '@/components/parts/CustomizationSelector'
import DimensionSelector from '@/components/parts/DimensionSelector'
import { required, requiredIf } from 'vuelidate/lib/validators'

const gConfig = require('../../../gConfig.json')

export default {
  props: {
    edittingItem: {
      default: null
    },
    editChange: {
      default: null
    }
  },
  components: {
    FabricRangeSelector,
    FabricSelector,
    ColorSelector,
    CustomizationSelector,
    DimensionSelector
  },
  data () {
    return {
      batteryMotorOptions: [],
      wiredMotorOptions: [],
      wiredNonRTSMotorOptions: [],
      motorType: ['Battery', 'Wired', 'Wired (Non-RTS)'],
      controlType: ['Chain', 'Motor'],
      selectedFabricGroup: null,
      selectedFirstFabricGroup: null,
      selectedSecondFabricGroup: null,
      selectedFirstFabric: null,
      selectedSecondFabric: null,
      customInstall: false,
      readyToSubmitDimension: false,
      edit: false,
      item: {
        type: 'Double Roller Blind',
        fabric: null,
        color: null,
        name: null,
        width: null,
        drop: null,
        total: 0,
        orderID: null,
        installPrice: 0,
        notes: null,
        variations: {
          secondFabric: null,
          secondColor: null,
          fitting: null,
          bracketType: null,
          controlSide: null,
          rollDirection: null,
          controlType: null,
          motor: null,
          motorOption: null,
          remote: null,
          charger: null,
          automation: null,
          chainColor: null,
          bracketColor: null,
          baseRailShape: null,
          baseRailColor: null
        }
      },
      incInstall: gConfig.install
    }
  },
  validations: {
    item: {
      fabric: { required },
      color: { required },
      name: { required },
      drop: { required },
      width: { required },
      variations: {
        secondFabric: { required },
        secondColor: { required },
        fitting: { required },
        bracketType: { required },
        controlSide: { required },
        rollDirection: { required },
        controlType: {required},
        motor: {
          required: requiredIf(function () {
            return this.item.variations.controlType === 'Motor'
          })
        },
        motorOption: {
          required: requiredIf(function () {
            return this.item.variations.motor !== null
          })
        },
        remote: {
          required: requiredIf(function () {
            return this.item.variations.motor !== null && this.item.variations.motor !== 'Wired (Non-RTS)'
          })
        },
        chainColor: {
          required: requiredIf(function () {
            return this.item.variations.controlType === 'Chain'
          })
        },
        bracketColor: { required },
        baseRailShape: { required },
        baseRailColor: { required }
      }
    },
    selectedFabricGroup: { required }
  },
  mounted () {
    this.useEdittingItem(this.edittingItem)
  },
  watch: {
    selectedFabricGroup: function (val) {
      switch (val) {
        case '5b3d99a87636707f2336ced6': // BO + SS
          this.selectedFirstFabricGroup = '5b3d99a87636707f2336ced3' // BO
          this.selectedSecondFabricGroup = '5b3d99a87636707f2336ced5' // SS
          break
        case '5b3d99a87636707f2336ced7': // BO + LF
          this.selectedFirstFabricGroup = '5b3d99a87636707f2336ced3' // BO
          this.selectedSecondFabricGroup = '5b3d99a87636707f2336ced4' // LF
          break
        case '5b3d99a87636707f2336ced8': // LF + SS
          this.selectedFirstFabricGroup = '5b3d99a87636707f2336ced4' // LF
          this.selectedSecondFabricGroup = '5b3d99a87636707f2336ced5' // SS
          break
      }
    },
    item: {
      handler (item) {
        this.getPrice(item)
      },
      deep: true
    },
    customInstall (val) {
      if (!val) {
        this.item.installPrice = 0
      }
    },
    selectedFirstFabric (val) {
      this.item.fabric = val
    },
    selectedSecondFabric (val) {
      this.item.variations.secondFabric = val
    },
    edittingItem (item) {
      this.useEdittingItem(item)
    },
    'item.variations.bracketType': {
      handler (item) {
        if (!this.edit) {
          this.item.variations.rollDirection = null
          this.$v.item.variations.rollDirection.$reset()
        }
      },
      deep: true
    },
    'item.variations.controlType': {
      handler (item) {
        if (!this.edit) {
          this.resetControlType()
        }
      },
      deep: true
    },
    'item.width': {
      handler (item) {
        if (!this.edit) {
          this.item.variations.motorOption = null
          this.item.variations.remote = null
          this.item.variations.charger = null
          this.item.variations.automation = null
        }
        this.changeMotorOptions()
      },
      deep: true
    }
  },
  methods: {
    changeMotorOptions () {
      let width = this.item.width
      this.controlType = ['Chain', 'Motor']
      this.motorType = ['Battery', 'Wired', 'Wired (Non-RTS)']
      if (width <= 709) {
        this.batteryMotorOptions = []
        this.motorType = ['Wired', 'Wired (Non-RTS)']
      } else if (width >= 710) {
        this.batteryMotorOptions = ['Somfy Sonesse 30 2.0nm ($295)']
      }

      if (width <= 594) {
        this.wiredMotorOptions = []
        this.wiredNonRTSMotorOptions = []
        this.controlType = ['Chain']
        if (this.item.variations.controlType === 'Motor') {
          this.item.variations.controlType = null
        }
      } else if (width >= 595) {
        this.wiredMotorOptions = ['Somfy Altus 40mm RTS ($265)', 'Somfy Sonesse RTS 40mm ($380)']
        this.wiredNonRTSMotorOptions = ['Somfy LS 40 ($250)', 'Somfy Sonesse WT 40 ($340)']
      }
    },
    resetControlType () {
      this.item.variations.chainColor = null
      this.$v.item.variations.chainColor.$reset()
      this.item.variations.motor = null
      this.$v.item.variations.motor.$reset()
      this.item.variations.motorOption = null
      this.$v.item.variations.motorOption.$reset()
      this.item.variations.remote = null
      this.item.variations.charger = null
      this.item.variations.automation = null
    },
    async getPrice (item) {
      const response = await ItemService.getPricing(item)
      if (response.data.price) {
        this.item.total = response.data.price
      }
    },

    setRoom (room) {
      this.item.width = room.width
      this.item.drop = room.drop
      this.item.name = room.name
    },

    useEdittingItem (item) {
      if (!this.editChange) {
        if (item) {
          this.edit = true
          this.item = item
          this.selectedFirstFabricGroup = (item.fabric.group._id ? item.fabric.group._id : item.fabric.group)
          this.selectedFirstFabric = (item.fabric._id ? item.fabric._id : item.fabric)
          this.item.color = (item.color._id ? item.color._id : item.color)

          this.selectedSecondFabricGroup = (item.variations.secondFabric.group._id ? item.variations.secondFabric.group._id : item.variations.secondFabric.group)
          this.selectedSecondFabric = (item.variations.secondFabric._id ? item.variations.secondFabric._id : item.variations.secondFabric)
          this.item.variations.secondColor = (item.variations.secondColor._id ? item.variations.secondColor._id : item.variations.secondColor)

          this.setSelectedFabricGroup()

          this.customInstall = parseInt(item.installPrice) > 0

          // for editing online orders
          if (this.item.variations.fitting) {
            switch (this.item.variations.fitting) {
              case 'Face':
                this.item.variations.fitting = 'Face Fit'
                break
              case 'Recess':
                this.item.variations.fitting = 'Recess Fit'
                break
            }
          }
          if (this.item.variations.driveControl) {
            this.item.variations.controlType = this.item.variations.driveControl
            this.item.variations.motorOption = this.item.variations.motor
            this.item.variations.motor = this.item.variations.motorType

            switch (this.item.variations.motorOption) {
              case 'Somfy Altus 28 1.5nm':
                this.item.variations.motorOption = 'Somfy Altus 28 1.5nm ($210)'
                break
              case 'Somfy Sonesse 30 2.0nm':
                this.item.variations.motorOption = 'Somfy Sonesse 30 2.0nm ($295)'
                break
              case 'Somfy Altus 40mm RTS':
                this.item.variations.motorOption = 'Somfy Altus 40mm RTS ($265)'
                break
              case 'Somfy Sonesse RTS 40mm':
                this.item.variations.motorOption = 'Somfy Sonesse RTS 40mm ($380)'
                break
            }

            delete this.item.variations.driveControl
            delete this.item.variations.motorType
          }
          // for editing online orders
        }
      } else {
        this.item = {
          _id: item._id,
          type: 'Double Roller Blind',
          fabric: null,
          color: null,
          name: item.name,
          width: item.width,
          drop: item.drop,
          total: 0,
          orderID: item.orderID,
          installPrice: 0,
          notes: null,
          variations: {
            secondFabric: null,
            secondColor: null,
            fitting: null,
            bracketType: null,
            controlSide: null,
            rollDirection: null,
            controlType: null,
            motor: null,
            motorOption: null,
            chainColor: null,
            bracketColor: null,
            baseRailShape: null,
            baseRailColor: null
          }
        }
      }
    },

    setSelectedFabricGroup () {
      if (this.selectedFirstFabricGroup === '5b3d99a87636707f2336ced3' && this.selectedSecondFabricGroup === '5b3d99a87636707f2336ced5') {
        this.selectedFabricGroup = '5b3d99a87636707f2336ced6'
      } else if (this.selectedFirstFabricGroup === '5b3d99a87636707f2336ced3' && this.selectedSecondFabricGroup === '5b3d99a87636707f2336ced4') {
        this.selectedFabricGroup = '5b3d99a87636707f2336ced7'
      } else if (this.selectedFirstFabricGroup === '5b3d99a87636707f2336ced4' && this.selectedSecondFabricGroup === '5b3d99a87636707f2336ced5') {
        this.selectedFabricGroup = '5b3d99a87636707f2336ced8'
      }
    },

    addItem () {
      this.$refs.dimensionSelector.touch()
      this.$v.item.$touch()
      this.$v.selectedFabricGroup.$touch()
      if (this.$v.item.$pending || this.$v.item.$error || !this.readyToSubmitDimension || this.$v.selectedFabricGroup.$pending || this.$v.selectedFabricGroup.$error) return

      this.edit = false

      this.$emit('create-item', this.item)
    },
    resetMotorOptions () {
      this.item.variations.motorOption = null
      this.item.variations.remote = null
      this.item.variations.charger = null
      this.item.variations.automation = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/products/DoubleRollerBlind.vue